import { API } from 'aws-amplify';

export default {
    methods: {
        async downloadTemplate(downloadParams) {
            try {
                let apiName = 's3downloadlink';
                let path = '/download-templates';
                let params = {
                    queryStringParameters: {
                      "bucket": downloadParams.bucket,
                      "key": downloadParams.key
                    }, 
                }
        
                const result = await API.get(apiName, path, params);
                const csvParse = this.$papa.parse(result.csvBody)
        
                this.$papa.download(csvParse.data, downloadParams.fileName) 
              } catch (e) {
                throw e
              } 
        },
        /**
         * Downloads entity using server-side processing via SQS
         */
        async $_entity_download_zip({
            userId, 
            group, 
            type,
            ids = [],
            staffId = null,
            textNotification = null,
            dateFormat = null,
            timeFormat = null,
            locale = null
        }) {

            if (!userId || !group) {
                const error = new Error('Missing required parameters');
                this.displayUserError(error);
                return;
            }

            if (!ids || ids.length === 0) {
                const error = new Error('No ids selected');
                this.displayUserError(error);
                return;
            }

            this.displayUserNotification({
                title: `Preparing ${textNotification} for Download`,
                type: "info",
                duration: 3000,
                message: 'Hera will send you a notification when your download is ready.'
            });

            try {
                const apiName = "downloadFiles";
                const path = "/download-files-zip";
                const params = {
                body: {
                    userId: userId,
                    group: group,
                    type,
                    textNotification,
                    filters: {
                        ids: ids,
                        ...(staffId && { staffId })
                    },
                    ...(dateFormat && { dateFormat }),
                    ...(timeFormat && { timeFormat }),
                    ...(locale && { locale })
                }
                };

                await API.post(apiName, path, params);

            } catch (error) {
                console.error('Export error:', error);
                
                this.displayUserNotification({
                title: 'Export Failed',
                type: "error",
                duration: 3000,
                message: 'Unable to queue export job. Please try again.'
                });
            }
        },

    }
}